// extracted by mini-css-extract-plugin
export default {"columnHeader":"DuplicateColumns_columnHeader__dSzkU","cell":"DuplicateColumns_cell__phh1A","actionCell":"DuplicateColumns_actionCell__2B0c-"};